import styled, { css } from "styled-components";
import { remCalc, media } from "./style-utils-coras-nua";
import {
    compose,
    space,
    SpaceProps,
    layout,
    LayoutProps,
    color,
    ColorProps,
    flexbox,
    FlexboxProps,
    position,
    PositionProps,
    border,
    BorderProps,
    shadow,
    ShadowProps,
    typography,
    TypographyProps
} from "styled-system";
import defaultTheme from "./theme-test-override";
import { ThemeProps, ThemeTemplate } from "./theme-template";

type BoxTypes = SpaceProps &
    LayoutProps &
    ColorProps &
    FlexboxProps &
    TypographyProps &
    ShadowProps &
    PositionProps &
    BorderProps & { clear?: any } & ThemeProps;
type PageContainerTypes = SpaceProps &
    LayoutProps &
    FlexboxProps &
    PositionProps &
    ThemeProps;
type PageActionsContainerTypes = SpaceProps &
    LayoutProps &
    FlexboxProps &
    ColorProps &
    ThemeProps;
type DisplayImageTypes = SpaceProps & LayoutProps & PositionProps;

//Simple box that's highly configurable
const Box = styled.div<BoxTypes>`
    ${compose(
        space,
        layout,
        color,
        flexbox,
        position,
        border,
        typography,
        shadow
    )}
    ${props => (props.clear ? `clear: ${props.clear}` : "")}
`;

/* eslint-disable no-debugger, no-console */
const PageActionsContainer = styled.div<PageActionsContainerTypes>`
    ${compose(space, color, layout, flexbox)}
    box-sizing: border-box;
    > * {
        order: 2;
        margin-left: 0;
        margin-right: 0;
        ${media.xs.down`
            &[back] {
                flex: inherit;
            }`}
    }
    > *:first-child {
        margin-right: 0;
    }
    > *:last-child {
        margin-left: 0;
    }
    [back] {
        margin-left: 0;
        margin-right: ${remCalc(12)};
        min-width: 0;
        order: 1;
        + * {
            margin-left: auto;
            margin-right: 0;
            ${media.sm.down`
                flex: 1;`}
        }
    }
    ${media.xs.down`
        > *:not([back]):not([forward]) {
            flex: 1 1 0;
        }
        &.block{
            > *:not([back]) {
                flex: 100%;
            }
        }
    `}
    > *:only-child {
        margin-left: auto;
        margin-right: 0;
        &[back] {
            margin-left: 0;
        }
        &:not([forward]) {
            ${media.sm.down`
            flex-grow: 1;
            margin-left: 0;
            margin-right: 0;`}
        }
    }
    &.block {
        width: 100%;
        ${media.sm.up`
            width: 70%;`}
        flex-wrap: wrap;
        margin-left: auto;
        margin-right: auto;
        > *:first-child,
        > *:last-child,
        > *:only-child,
        > * {
            width: 100%;
            margin-left: 0;
            margin-right: 0;
            &[back] {
                justify-content: center;
                width: 100%;
                order: 2;
                margin-right: 0;
            }
        }
    }
    &.u-back-as-secondary {
        width: 100%;
    }
`;

PageActionsContainer.defaultProps = {
    color: "monotoneDark",
    pt: 10,
    pb: [0, 0, 0],
    px: 0,
    justifyContent: "space-between",
    height: "auto",
    display: "flex",
    theme: {
        ...defaultTheme
    } as ThemeTemplate
};
const PageContainer = styled(Box)<PageContainerTypes>`
    box-sizing: border-box;
    > * {
        flex-shrink: 1;
    }
    ${PageActionsContainer}:last-of-type {
        padding-bottom: ${remCalc(36)};
        margin-top: ${remCalc(36)};
        // ${media.sm.down` ${css`
            //     padding-bottom: 0;
            //
        `}`}
    }

    &.not-found-container {
        & > svg {
            margin: 0 auto ${remCalc(50)} auto;
        }
        & > a {
            margin: 0 0 ${remCalc(8)} 0;
            padding: 0;
        }
    }
`;
PageContainer.defaultProps = {
    theme: {
        ...defaultTheme
    } as ThemeTemplate,
    pt: [14, 14, 14, 14, 24, 16],
    pl: [4, 4, 4, 14],
    pr: [4, 4, 4, 14],
    pb: 0,
    mx: "auto",
    maxWidth: 624,
    width: ["100%"],
    display: "flex",
    flexDirection: "column",
    flexGrow: [1, 1, 1, 0],
    flexShrink: 0,
    position: "relative",
    maxHeight: [null, null, null]
};

const SideContainer = styled(PageContainer)``;
SideContainer.defaultProps = {
    pl: [4, 4, 4, 14],
    pt: [6, 6, 14],
    pr: 8,
    pb: [6, 6, 14]
};

const DisplayImage = styled.div<DisplayImageTypes>`
    ${compose(space, layout, position)}
`;
DisplayImage.defaultProps = {
    theme: {
        ...defaultTheme
    },
    display: "block",
    mb: 5,
    mx: "auto",
    position: "relative"
};

export {
    PageContainer,
    SideContainer,
    PageActionsContainer,
    DisplayImage,
    Box
};
